import { AxiosRequestConfig } from 'axios';
import { privateFetcher } from 'services';
import ENDPOINTS from '../constants/endpoints.constants';
import APIError from '../exceptions/APIError';

export const upload = async (
  body: FormData,
  orgId: number,
  options: AxiosRequestConfig,
): Promise<{ url: string }> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/upload/${orgId}`;
    const { data } = await privateFetcher.post(url, body, options);
    return data.data;
  } catch (error) {
    throw new APIError(error.message);
  }
};
